import { createFileRoute } from '@tanstack/react-router';
import { ExclusionsPage } from '@/features/settings/exclusions/ExclusionsPage';
import { ExclusionsSearch, PAGINATION_DEFAULTS, stripDefaults } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/settings/exclusions')({
  validateSearch: ExclusionsSearch,
  search: { middlewares: [stripDefaults(ExclusionsSearch, PAGINATION_DEFAULTS)] },
  component: ExclusionsPage,
});
